import * as renders from './renders/index'
const { hasChildren, hasProperty, getProperty, SLIDE_SIZE_PX } = require('./helpers')

const RENDERS = {
  // svg tags
  text: renders.renderSvgText,
  image: renders.renderImage,
  rect: renders.renderRect,
  // classes
  'ai-inline-svg': renders.renderInlineSvg,
  'ai-chart-bar': renders.renderBarChart,
  'ai-chart-pie': renders.renderPieChart,
  'ai-chart-multi-line': renders.renderMultilineChart,
  'ai-chart-bar-stack': renders.renderBarStackedChart,
  'render-bar-stacked-cartesian-chart': renders.renderBarStackedCartesianChart,
  // 'st-donut-chart': renders.renderDonutChart,
  'world-map': renders.renderInlineSvg,
}

function getTransformValues(svgNode) {
  const parenthesesRegExp = /\(([^)]+)\)/
  const translateXY = hasProperty('transform', svgNode)
    ? parenthesesRegExp.exec(svgNode.properties.transform)[1].split(',')
    : ''
  const translateX = translateXY ? Number(translateXY[0]) : 0
  const translateY = translateXY ? Number(translateXY[1]) : 0

  return { translateX, translateY }
}

function getPositioning(svgNode, parent) {
  const { translateX, translateY } = getTransformValues(svgNode)

  const x = getProperty(svgNode, 'x', 0)
  const y = getProperty(svgNode, 'y', 0)
  const height = getProperty(svgNode, 'height', parent.height)
  const width = getProperty(svgNode, 'width', parent.width)
  const yAcc = parent.yAcc + (y + translateY) / SLIDE_SIZE_PX.y
  const xAcc = parent.xAcc + (x + translateX) / SLIDE_SIZE_PX.x

  return { x, y, height, width, translateX, translateY, yAcc, xAcc }
}

function renderSvgElement(parent, slide, svgNode) {
  const { yAcc, xAcc, ...positioning } = getPositioning(svgNode, parent)

  // FIXME: refactor: use data attributes instead of class
  // TODO: some components are in uikit and need to be changed there to finally drop classes
  // data-custom-render > class (but only for svg and foreign object) > tagName
  const elementType =
    svgNode?.properties?.['data-custom-render'] ||
    ((svgNode.tagName === 'svg' || svgNode.tagName === 'foreignObject') &&
      svgNode?.properties?.class) ||
    svgNode?.tagName

  if (typeof RENDERS[elementType] === 'function') {
    RENDERS[elementType]({ ...positioning, parent, svgNode, slide })
  }

  const elementsToStopRecursiveRender = [
    'ai-inline-svg',
    'ai-chart-multi-line',
    'ai-chart-pie',
    'ai-chart-bar',
    'ai-chart-bar-stack',
    'render-bar-stacked-cartesian-chart',
    'world-map',
  ]
  if (elementType && elementsToStopRecursiveRender.includes(elementType)) {
    return
  }

  if (hasChildren(svgNode)) {
    for (const child of svgNode.children) {
      renderSvgElement({ ...positioning, yAcc, xAcc }, slide, child)
    }
  }
}

export default renderSvgElement
